module.exports = __webpack_public_path__ + "media/images/users/user-4-460f65cf4bf41c294902fcee46e01f1e.jpg";